import React, { useEffect } from 'react';
import './Toast.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationCircle, faInfoCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

/**
 * Componente Toast para notificaciones
 * @param {string} message - Mensaje a mostrar
 * @param {string} type - Tipo: 'success', 'error', 'warning', 'info'
 * @param {number} duration - Duración en ms (default: 3000)
 * @param {function} onClose - Callback cuando se cierra
 * @param {boolean} show - Si debe mostrarse
 */
const Toast = ({ message, type = 'success', duration = 3000, onClose, show }) => {
    useEffect(() => {
        if (show && duration > 0) {
            const timer = setTimeout(() => {
                if (onClose) onClose();
            }, duration);

            return () => clearTimeout(timer);
        }
    }, [show, duration, onClose]);

    if (!show) return null;

    const icons = {
        success: faCheckCircle,
        error: faTimesCircle,
        warning: faExclamationCircle,
        info: faInfoCircle,
    };

    const icon = icons[type] || icons.info;

    return (
        <div className={`toast-notification toast-${type} toast-show`}>
            <div className="toast-icon">
                <FontAwesomeIcon icon={icon} />
            </div>
            <div className="toast-message">{message}</div>
            <button className="toast-close" onClick={onClose}>
                ×
            </button>
        </div>
    );
};

export default Toast;
